export default __webpack_public_path__ + "static/media/papandayan-5.6844e246.jpg";